<template>
  <div>
    <!-- 定时刷新 -->
    <div style="float: right; margin-bottom: 10px">
      <el-select v-model="time" size="mini" class="selectlist">
        <el-option v-for="item in setTime" :key="item.value" :label="item.name" :value="item.value"></el-option>
      </el-select>
    </div>
    <el-table :data="dataList" border size="mini" style="margin-top:25px" height="650" :row-key="getKey"
      :header-cell-style="{ background: '#e4f1ff' }" @sort-change="sortChange">
      <el-table-column :reserve-selection="true" :selectable="checkboxInit" type="selection" min-width="40">
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.serialNumber')" width="60px">
        <template slot-scope="scope">
          <span v-if="scope.$index !== 0" class="fontStyle">{{ scope.$index }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.alias')" prop="alias" sortable="custom" min-width="150px">
        <template slot-scope="scope">
          <el-input class="selectlist" v-if="scope.$index === 0" size="mini"
            :placeholder="$t('lang.HangingDevice.alias')" v-model="params.alias" clearable></el-input>
          <div v-else>
            <span class="fontStyle" v-if="scope.row.alias">{{ scope.row.alias }}</span>
            <span class="fontStyle" v-else>{{ scope.row.printer }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.did')" prop="did" sortable="custom" width="140px">
        <template slot-scope="scope">
          <el-input class="selectlist" v-if="scope.$index === 0" size="mini" :placeholder="$t('lang.HangingDevice.did')"
            v-model="params.did" clearable></el-input>
          <span class="fontStyle" v-else>{{ scope.row.did }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.dsn')" prop="dsn" sortable="custom" width="200px">
        <template slot-scope="scope">
          <el-input class="selectlist" v-if="scope.$index === 0" size="mini" :placeholder="$t('lang.HangingDevice.dsn')"
            v-model="params.dsn" clearable></el-input>
          <span class="fontStyle" v-else>{{ scope.row.dsn }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.printeMethod')" prop="printType">
        <template slot-scope="scope">
          <div v-if="scope.$index !== 0">
            <span v-if="scope.row.printType == 0" class="fontStyle">socket</span>
            <span v-else class="fontStyle">http</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.vendor')" prop="vendor" sortable="custom" width="140PX">
        <template slot-scope="scope">
          <el-input class="selectlist" v-if="scope.$index === 0" size="mini"
            :placeholder="$t('lang.HangingDevice.vendor')" v-model="params.vendor" clearable></el-input>
          <span class="fontStyle" v-else>{{ scope.row.vendor }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.type')" prop="type" sortable="custom" min-width="150px">
        <template slot-scope="scope">
          <el-input class="selectlist" v-if="scope.$index === 0" size="mini"
            :placeholder="$t('lang.HangingDevice.type')" v-model="params.type" clearable></el-input>
          <span class="fontStyle" v-else>{{ scope.row.type }}</span>
        </template>
      </el-table-column>
      <el-table-column label="PID" prop="description">
        <template slot-scope="scope">
          <span class="fontStyle" v-if="scope.$index !== 0">{{ scope.row.pid }}</span>
        </template>
      </el-table-column>
      <el-table-column label="VID" prop="description">
        <template slot-scope="scope">
          <span class="fontStyle" v-if="scope.$index !== 0">{{ scope.row.vid }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.port')" prop="port">
        <template slot-scope="scope">
          <span v-if="scope.$index !== 0" class="fontStyle">{{ scope.row.port }}</span>
        </template>
      </el-table-column>

      <el-table-column :label="$t('lang.HangingDevice.status')" prop="status" align="center" sortable="custom"
        width="150px">
        <template slot-scope="scope">
          <el-select class="selectlist" v-if="scope.$index === 0" size="mini"
            :placeholder="$t('lang.HangingDevice.status')" v-model="params.status" clearable>
            <el-option :label="$t('lang.HangingDevice.online')" :value="1"></el-option>
            <el-option :label="$t('lang.HangingDevice.offline')" :value="0"></el-option>
          </el-select>
          <div v-else-if="scope.row.status == 1">
            <el-tag type="success" v-if="scope.row.dstate == 3">{{ $t('lang.HangingDevice.online') }}</el-tag>
            <el-tag type="danger" v-else>{{ $t('lang.HangingDevice.offline') }}</el-tag>
          </div>
          <div v-else>
            <el-tag type="danger">{{ $t('lang.HangingDevice.offline') }}</el-tag>
          </div>
        </template>
      </el-table-column>

      <el-table-column :label="$t('lang.HangingDevice.lastts')" prop="lastDateTime" sortable="custom" width="150px">
        <template slot-scope="scope">
          <span v-if="scope.$index !== 0" class="fontStyle">{{ scope.row.lastDateTime }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.HangingDevice.Description')" prop="description" min-width="130px">
        <template slot-scope="scope">
          <span v-if="scope.$index !== 0" class="fontStyle">{{ scope.row.description }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('lang.Button.operation')" align="center">
        <template slot-scope="scope">
          <el-button v-if="scope.$index !== 0" circle type="primary" icon="el-icon-edit"
            @click="editPrintType(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="con">
      <el-pagination layout="total, sizes, prev, pager, next, jumper" :current-page="pageParams.current"
        :page-size="pageParams.size" :page-sizes="[10, 25, 50, 100]" :total="pageParams.total" @size-change="sizeChange"
        @current-change="currentChange">
      </el-pagination>
    </div>
    <edit-dialog ref="editDialog" @updateList="getList"></edit-dialog>
  </div>
</template>
<script>
import { queryHangingDevice } from '@/api/hangingDevice'
import TableComponent from '@/components/TableComponent/index'
import editDialog from './component/editDialog'
import { cloneDeep } from 'lodash' // js库
export default {
  name: 'HangingDevice',
  components: {
    TableComponent,
    editDialog
  },
  data() {
    return {
      dataList: [],
      pageParams: {
        current: 1,
        total: 0,
        size: 10
      },
      params: {
        offset: 1, // 当前页
        limit: 10, // 页最大数量
        alias: '',
        vendor: '',
        type: '',
        status: '',
        // lastts: '',
        did: '',
        dsn: '',
        seq: ''
      },
      // 复制查询params对象，防止在请求列表数据时处理params对象监听到发生变化，发起两次请求，达到减少请求次数的目的
      paramsCopy: {},
      //定时刷新数据
      setTime: [
        { name: this.$t("lang.devicelist.batch"), value: 99999999999 },
        { name: this.$t("lang.devicelist.L5Nrefresh"), value: 5000 },
        { name: this.$t("lang.devicelist.L10Nrefresh"), value: 10000 },
        { name: this.$t("lang.devicelist.L20Nrefresh"), value: 20000 },
        { name: this.$t("lang.devicelist.L60Nrefresh"), value: 60000 }
      ],
      time: 10000, // 默认10s刷新
      setIntervals: null,// 定时函数
    }
  },
  watch: {
    'params.alias': {
      handler: function (val) {
        this.params.offset = 1
        this.getList()
      }
    },
    'params.vendor': {
      handler: function (val) {
        // this.params.offset = 1    
        // this.getList()
      }
    },
    'params.type': {
      handler: function (val) {
        // this.params.offset = 1    
        // this.getList()
      }
    },
    'params.status': {
      handler: function (val) {
        this.params.offset = 1
        this.getList()
      }
    },
    'params.did': {
      handler: function (val) {
        this.params.offset = 1
        this.getList()
      }
    },
    'params.dsn': {
      handler: function (val) {
        this.params.offset = 1
        this.getList()
      }
    },
    'params.seq': {
      handler: function (val) {
        this.params.offset = 1
        this.getList()
      }
    },
    // 监听刷新下拉框选择的变化
    time(newTime) {
      clearInterval(this.setIntervals)
      this.setIntervals = setInterval(() => {
        this.getList()
      }, newTime)
    }
  },
  // 缓存路由时，每次重进进入该路由触发该钩子，缓存路由时，mouted只在第一次会触发，
  mounted() {
    this.getList()
  },
  activated() {
    this.setIntervals = setInterval(() => {
      this.getList()
    }, this.time)
  },
  // 缓存路由时，离开路由时触发该钩子
  deactivated() {
    clearInterval(this.setIntervals);
  },
  methods: {
    // getKey 配合reserve-selection使用，在表格翻页数据刷新时记住上一页的勾选
    getKey(key) {
      return key.id
    },
    // 禁止表格第一行勾选
    checkboxInit(row, index) {
      if (index == 0) {
        return 0;
      } else {
        return 1;
      }
    },
    // 处理空值
    handleData() {
      // 深拷贝
      this.paramsCopy = cloneDeep(this.params)
      this.paramsCopy.alias = this.paramsCopy.alias ? this.paramsCopy.alias : undefined
      this.paramsCopy.vendor = this.paramsCopy.vendor ? this.paramsCopy.vendor : undefined
      this.paramsCopy.type = this.paramsCopy.type ? this.paramsCopy.type : undefined
      if (this.paramsCopy.status === '') {
        this.paramsCopy.status = undefined
      }
      this.paramsCopy.did = this.paramsCopy.did ? this.paramsCopy.did : undefined
      this.paramsCopy.dsn = this.paramsCopy.dsn ? this.paramsCopy.dsn : undefined
      this.paramsCopy.seq = this.paramsCopy.seq ? this.paramsCopy.seq : undefined
    },
    // 获取数据
    getList() {
      this.handleData()
      queryHangingDevice(this.paramsCopy).then(res => {
        console.log(res);
        if (res.data.code === 0) {
          let data = res.data.data
          this.dataList = data.list || []
          this.pageParams.total = data.total
          this.pageParams.current = data.offset
          this.pageParams.size = data.limit
          this.dataList.unshift({})
        } else {
          res.data.error_message && this.$message.error(res.data.error_message)
        }
      }).catch(() => { })
    },
    sizeChange(size) {
      this.params.limit = size
      this.getList()
    },
    currentChange(current) {
      this.params.offset = current
      this.getList()
    },
    // 排序
    sortChange(column) {
      let prop = column.prop
      if (column.order === 'descending') {
        if (prop === 'alias') {
          this.params.seq = 2
        } else if (prop === 'vendor') {
          this.params.seq = 4
        } else if (prop === 'type') {
          this.params.seq = 6
        } else if (prop === 'status') {
          this.params.seq = 8
        } else if (prop === 'lastDateTime') {
          this.params.seq = 10
        } else if (prop === 'did') {
          this.params.seq = 12
        } else if (prop === 'dsn') {
          this.params.seq = 14
        }
      } else {
        if (prop === 'alias') {
          this.params.seq = 1
        } else if (prop === 'vendor') {
          this.params.seq = 3
        } else if (prop === 'type') {
          this.params.seq = 5
        } else if (prop === 'status') {
          this.params.seq = 7
        } else if (prop === 'lastDateTime') {
          this.params.seq = 9
        } else if (prop === 'did') {
          this.params.seq = 11
        } else if (prop === 'dsn') {
          this.params.seq = 13
        }
      }
    },
    // 编辑
    editPrintType(row) {
      this.$refs.editDialog.show(row)
    }
  }
}
</script>
<style scoped>
.con {
  text-align: center;
  margin-top: 0.4rem;
}

.selectlist {
  width: 2rem;
}

.fontStyle {
  font-size: 0.25rem;
  height: 41px;
}
</style>